module.exports = __webpack_public_path__ + "static/media/feat9en@2x.086ea3bd.png";